class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.addEventListener(
      'click',
      this.handleCustomCartActions.bind(this)
    );

    this.addShippingStyles();
    this.setHeaderCartIconAccessibility();
    this.restoreDiscountField();
    this.restoreShippingZip();
  }

  /* Estilo das opções de frete */
  addShippingStyles() {
    if (document.getElementById('emporio-shipping-styles')) return;

    const style = document.createElement('style');
    style.id = 'emporio-shipping-styles';

    style.textContent = `
      #CartDrawer-ShippingResults {
        display: grid;
        gap: 7px;
        margin-top: 12px;
        width: 100%;
      }

      #CartDrawer-ShippingResults .cart-drawer-shipping-rate {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        gap: 5px 12px;
        padding: 10px 12px;
        border: 1px solid transparent;
        border-radius: 8px;
        background: #f5f5f5;
        font-size: 12px;
        line-height: 1.4;
      }

      #CartDrawer-ShippingResults
      .cart-drawer-shipping-rate.has-deadline {
        grid-template-columns: minmax(0, 1fr) auto auto;
      }

      #CartDrawer-ShippingResults
      .cart-drawer-shipping-rate.is-local {
        border-color: #b7a0cf;
        background: #f7f3fb;
      }

      #CartDrawer-ShippingResults .shipping-rate-name {
        min-width: 0;
        overflow-wrap: anywhere;
      }

      #CartDrawer-ShippingResults .shipping-rate-price {
        font-size: inherit;
        font-weight: 500;
        white-space: nowrap;
      }

      #CartDrawer-ShippingResults .shipping-rate-deadline {
        color: #777;
        font-size: 11px;
        text-align: right;
      }

      @media (max-width: 380px) {
        #CartDrawer-ShippingResults
        .cart-drawer-shipping-rate.has-deadline {
          grid-template-columns: minmax(0, 1fr) auto;
        }

        #CartDrawer-ShippingResults .shipping-rate-deadline {
          grid-column: 1 / -1;
          text-align: left;
        }
      }
    `;

    document.head.appendChild(style);
  }

  restoreDiscountField() {
    const savedCode = localStorage.getItem('cart_discount_code');
    if (!savedCode) return;

    const input = this.querySelector('#CartDrawer-Discount');
    const message = this.querySelector('#CartDrawer-DiscountMessage');

    if (input) input.value = savedCode;
    if (message) message.textContent = 'Cupom aplicado.';
  }

  restoreShippingZip() {
    const savedZip = localStorage.getItem('cart_shipping_zip');
    if (!savedZip) return;

    const input = this.querySelector('#CartDrawer-Zip');
    if (input) input.value = savedZip;
  }

  recalculateSavedShipping() {
    const savedZip = localStorage.getItem('cart_shipping_zip');
    if (!savedZip) return;

    const input = this.querySelector('#CartDrawer-Zip');
    const button = this.querySelector('#CartDrawer-ZipButton');

    if (!input || !button) return;

    input.value = savedZip;

    setTimeout(() => {
      button.click();
    }, 150);
  }

  async updateCustomCartCount() {
    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const cartLink = document.querySelector('#cart-icon-bubble');

      if (!cartLink) return;

      const iconWrapper = cartLink.querySelector(
        '.custom-cart-icon-wrapper'
      );

      if (!iconWrapper) return;

      let countBubble = iconWrapper.querySelector(
        '.custom-cart-count'
      );

      if (cart.item_count > 0) {
        if (!countBubble) {
          countBubble = document.createElement('span');
          countBubble.className = 'custom-cart-count';
          iconWrapper.appendChild(countBubble);
        }

        countBubble.textContent = cart.item_count;
      } else if (countBubble) {
        countBubble.remove();
      }
    } catch (error) {
      console.error('Erro ao atualizar contador do carrinho:', error);
    }
  }

  async handleCustomCartActions(event) {
    const discountButton = event.target.closest(
      '#CartDrawer-DiscountButton'
    );

    const shippingButton = event.target.closest(
      '#CartDrawer-ZipButton'
    );

    /* =========================================================
       CUPOM
       ========================================================= */

    if (discountButton) {
      const input = this.querySelector('#CartDrawer-Discount');
      const message = this.querySelector('#CartDrawer-DiscountMessage');

      if (!input || !message) return;

      const code = input.value.trim();
      const root = window.Shopify?.routes?.root || '/';

      message.textContent = code
        ? 'Aplicando cupom...'
        : 'Removendo cupom...';

      try {
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: code,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();

        if (!response.ok) {
          console.error('Erro ao atualizar cupom:', data);
          throw new Error('Erro ao atualizar cupom.');
        }

        const cartCheckResponse = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });

        if (!cartCheckResponse.ok) {
          throw new Error('Não foi possível verificar o cupom.');
        }

        const cartCheck = await cartCheckResponse.json();

        const discountApplications =
          cartCheck.cart_level_discount_applications || [];

        const discountCodes = cartCheck.discount_codes || [];

        const couponApplied =
          code &&
          (
            discountApplications.some((discount) =>
              (discount.title || '').toLowerCase() ===
              code.toLowerCase()
            ) ||
            discountCodes.some((discount) =>
              (discount.code || '').toLowerCase() ===
                code.toLowerCase() &&
              discount.applicable !== false
            )
          );

        if (couponApplied) {
          localStorage.setItem('cart_discount_code', code);
        } else {
          localStorage.removeItem('cart_discount_code');
        }

        if (data.sections) this.renderContents(data);

        setTimeout(() => {
          const newInput = this.querySelector('#CartDrawer-Discount');
          const newMessage = this.querySelector(
            '#CartDrawer-DiscountMessage'
          );

          if (newInput) newInput.value = code;

          if (newMessage) {
            newMessage.textContent = !code
              ? 'Cupom removido.'
              : couponApplied
                ? 'Cupom aplicado.'
                : 'Cupom inválido.';
          }

          this.recalculateSavedShipping();
        }, 100);
      } catch (error) {
        console.error(error);
        message.textContent = 'Não foi possível atualizar o cupom.';
      }

      return;
    }

    /* =========================================================
       CALCULAR FRETE
       ========================================================= */

    if (shippingButton) {
      const input = this.querySelector('#CartDrawer-Zip');
      const results = this.querySelector('#CartDrawer-ShippingResults');

      if (!input || !results) return;

      const zip = input.value.replace(/\D/g, '');

      if (zip.length !== 8) {
        results.textContent = 'Digite um CEP válido.';
        return;
      }

      results.textContent = 'Calculando frete...';
      shippingButton.disabled = true;

      const root = window.Shopify?.routes?.root || '/';

      try {
        const cepResponse = await fetch(
          `https://viacep.com.br/ws/${zip}/json/`
        );

        if (!cepResponse.ok) {
          throw new Error('Erro ao consultar CEP.');
        }

        const address = await cepResponse.json();

        if (address.erro) {
          results.textContent = 'CEP não encontrado.';
          return;
        }

        const cartResponse = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });

        if (!cartResponse.ok) {
          throw new Error('Não foi possível consultar o carrinho.');
        }

        const cartData = await cartResponse.json();
        const cartTotal = cartData.total_price / 100;

        const params = new URLSearchParams();
        params.append('shipping_address[zip]', zip);
        params.append('shipping_address[country]', 'Brazil');
        params.append('shipping_address[province]', address.uf);
        params.append('shipping_address[city]', address.localidade);

        const prepareResponse = await fetch(
          root + 'cart/prepare_shipping_rates.json?' + params.toString(),
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }
        );

        if (!prepareResponse.ok) {
          console.error(
            'Erro prepare_shipping_rates:',
            prepareResponse.status,
            await prepareResponse.text()
          );

          throw new Error('Não foi possível iniciar o cálculo.');
        }

        let rates = null;

        for (let attempt = 0; attempt < 15; attempt++) {
          await new Promise((resolve) => setTimeout(resolve, 700));

          const ratesResponse = await fetch(
            root + 'cart/async_shipping_rates.json?' + params.toString(),
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            }
          );

          if (!ratesResponse.ok) continue;

          const data = await ratesResponse.json();

          if (data && Array.isArray(data.shipping_rates)) {
            rates = data.shipping_rates;
            break;
          }
        }

        if (rates === null) {
          results.textContent =
            'O cálculo demorou mais que o esperado. Tente novamente.';
          return;
        }

        /* Frete grátis — SP Capital a partir de R$ 200 */
        const spCapitalPrefixes = [
          '010', '011', '012', '013', '014',
          '015', '016', '017', '018', '019',
          '020', '021', '022', '023', '024',
          '025', '026', '027', '028', '029',
          '030', '031', '032', '033', '034',
          '035', '036', '037', '038', '039',
          '040', '041', '042', '043', '044',
          '045', '046', '047', '048', '049',
          '050', '051', '052', '053', '054',
          '055', '056', '057', '058', '059',
          '067','080', '081', '082', '083',
          '084'
        ];

        const isSaoPauloCapital = spCapitalPrefixes.some(
          (prefix) => zip.startsWith(prefix)
        );

        const podeTerEntregaPropria =
          isSaoPauloCapital && cartTotal >= 200;

        let shippingRatesFiltrados = rates.filter((rate) => {
          const nome = (rate.name || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

          return (
            !nome.includes('emporio mix entrega') &&
            !nome.includes('local delivery')
          );
        });

        if (podeTerEntregaPropria) {
          shippingRatesFiltrados.unshift({
            name: 'Empório Mix',
            price: '0.00',
            localDeadline: 4,
            isLocal: true
          });
        }

        /* Expresso — R$ 12 sem pedido mínimo */
        const expressoPrefixes = [
          '010', '011', '012', '013', '014', '015',
          '020', '021', '022', '023', '024', '025',
          '026', '027', '028', '029', '030', '031',
          '032', '033', '034', '035', '036', '037',
          '038', '039', '040', '041', '042', '043',
          '045', '046', '047', '050', '051', '053',
          '054', '055', '056', '057', '060', '061',
          '062', '063', '064', '065', '066', '067',
          '068', '070', '071', '072', '074', '076',
          '077', '078', '079', '080', '081', '082',
          '083', '084', '085', '086', '087', '088',
          '090', '091', '092', '093', '095', '096',
          '097', '098', '099'
        ];

        const atendeExpresso = expressoPrefixes.some(
          (prefix) => zip.startsWith(prefix)
        );

        if (atendeExpresso) {
          shippingRatesFiltrados = shippingRatesFiltrados.filter(
            (rate) =>
              !/^(entrega expressa|expresso)$/i.test(
                (rate.name || '').trim()
              )
          );

          shippingRatesFiltrados.unshift({
            name: 'Entrega expressa',
            price: '12.00',
            localDeadline: 2,
            isLocal: true
          });
        }

        if (shippingRatesFiltrados.length === 0) {
          results.textContent =
            'Nenhuma opção de frete disponível para este CEP.';
          return;
        }

        /* Exibe nome, preço e prazo */
        const fragment = document.createDocumentFragment();

        shippingRatesFiltrados.forEach((rate) => {
          const price = Number(rate.price);

          const formattedPrice =
            price === 0
              ? 'Grátis'
              : new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                }).format(price);

          const row = document.createElement('div');
          row.className = 'cart-drawer-shipping-rate';

          if (rate.isLocal) {
            row.classList.add('is-local');
          }

          const nameElement = document.createElement('span');
          nameElement.className = 'shipping-rate-name';
          nameElement.textContent = rate.name || '';

          const priceElement = document.createElement('strong');
          priceElement.className = 'shipping-rate-price';
          priceElement.textContent = formattedPrice;

          row.append(nameElement, priceElement);

          /*
            As entregas locais possuem prazo definido.
            O campo de prazo das transportadoras será
            incluído após conferir a resposta da cotação.
          */
          if (rate.localDeadline) {
            const deadlineElement = document.createElement('span');
            deadlineElement.className = 'shipping-rate-deadline';

            const days = rate.localDeadline;

            deadlineElement.textContent =
              days === 1
                ? 'Em até 1 dia útil'
                : `Em até ${days} dias úteis`;

            row.classList.add('has-deadline');
            row.appendChild(deadlineElement);
          }

          fragment.appendChild(row);
        });

        results.replaceChildren(fragment);
        localStorage.setItem('cart_shipping_zip', zip);
      } catch (error) {
        console.error('Erro ao calcular frete:', error);

        results.textContent =
          'Não foi possível calcular o frete para este CEP.';
      } finally {
        shippingButton.disabled = false;
      }

      return;
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector(
      '[id^="Details-"] summary'
    );

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    const content = cartDrawerNote.nextElementSibling;

    if (content && content.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', content.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');

    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      if (!parsedState.sections || !parsedState.sections[section.id]) {
        return;
      }

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      this.restoreDiscountField();
      this.restoreShippingZip();
      this.updateCustomCartCount();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const result = super.updateQuantity(
      line,
      quantity,
      name,
      variantId
    );

    Promise.resolve(result).finally(() => {
      setTimeout(() => {
        const drawer = document.querySelector('cart-drawer');

        if (drawer) {
          drawer.restoreDiscountField();
          drawer.restoreShippingZip();
          drawer.updateCustomCartCount();
        }
      }, 300);
    });

    return result;
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}/* =========================================================
   SELEÇÃO DE FRETE, PRAZOS E TOTAL ESTIMADO
   Cole este bloco no final de cart-drawer.js.
   ========================================================= */

(() => {
  const Drawer = customElements.get('cart-drawer');

  if (!Drawer || Drawer.prototype.shippingSelectionEnabled) return;

  Drawer.prototype.shippingSelectionEnabled = true;

  const money = (cents) =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(cents / 100);

  const normalize = (text) =>
    String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  /* Substitui apenas o estilo das opções */
  document.getElementById('emporio-shipping-selection')?.remove();

  const style = document.createElement('style');
  style.id = 'emporio-shipping-selection';

  style.textContent = `
    cart-drawer .emporio-shipping-tool {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      align-items: center;
      column-gap: 12px;
      width: 100%;
    }

    cart-drawer .emporio-shipping-tool
    > .cart-drawer-tool__row {
      min-width: 0;
      width: 100%;
    }

    cart-drawer #CartDrawer-ShippingResults {
      grid-column: 1 / -1 !important;
      width: 100% !important;
      max-width: none !important;
      margin: 14px 0 0 !important;
      padding: 0 !important;
      display: grid !important;
      gap: 8px !important;
    }

    cart-drawer #CartDrawer-ShippingResults
    .cart-drawer-shipping-rate {
      box-sizing: border-box;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto auto !important;
      align-items: center;
      gap: 8px 14px !important;
      width: 100%;
      margin: 0 !important;
      padding: 12px 14px !important;
      border: 1px solid transparent !important;
      border-radius: 8px;
      background: #f5f5f5 !important;
      color: inherit;
      font-family: inherit;
      font-size: 12px;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      cursor: pointer;
      appearance: none;
    }

    cart-drawer #CartDrawer-ShippingResults
    .cart-drawer-shipping-rate.is-selected {
      border-color: #7952a3 !important;
      background: #f5f0fa !important;
    }

    cart-drawer #CartDrawer-ShippingResults
    .cart-drawer-shipping-rate:focus-visible {
      outline: 2px solid #7952a3;
      outline-offset: 2px;
    }

    cart-drawer #CartDrawer-ShippingResults
    .shipping-rate-name {
      min-width: 0;
      overflow-wrap: normal;
      word-break: normal;
    }

    cart-drawer #CartDrawer-ShippingResults
    .shipping-rate-price {
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
    }

    cart-drawer #CartDrawer-ShippingResults
    .shipping-rate-deadline {
      grid-column: auto !important;
      color: #777;
      font-size: 11px;
      text-align: right !important;
      white-space: nowrap;
    }

    cart-drawer #CartDrawer-ShippingResults
    .shipping-rate-deadline:empty {
      display: none;
    }

    cart-drawer #CartDrawer-ShippingResults
    .cart-drawer-shipping-rate.without-deadline {
      grid-template-columns: minmax(0, 1fr) auto !important;
    }

    @media (max-width: 390px) {
      cart-drawer #CartDrawer-ShippingResults
      .cart-drawer-shipping-rate {
        grid-template-columns: minmax(0, 1fr) auto !important;
        padding: 11px 12px !important;
      }

      cart-drawer #CartDrawer-ShippingResults
      .shipping-rate-deadline {
        grid-column: 1 / -1 !important;
        text-align: left !important;
      }
    }
  `;

  document.head.appendChild(style);

  const originalHandler = Drawer.prototype.handleCustomCartActions;

  Drawer.prototype.handleCustomCartActions = async function(event) {
    const shippingButton = event.target.closest(
      '#CartDrawer-ZipButton'
    );

    if (!shippingButton) {
      return originalHandler.call(this, event);
    }

    if (this.shippingSelectionBusy) return;

    this.shippingSelectionBusy = true;

    try {
      /* Executa o cálculo que já está funcionando */
      await originalHandler.call(this, event);

      const results = this.querySelector(
        '#CartDrawer-ShippingResults'
      );

      const input = this.querySelector('#CartDrawer-Zip');

      if (!results || !input) return;

      results.closest('.cart-drawer-tool')
        ?.classList.add('emporio-shipping-tool');

      const oldRows = Array.from(
        results.querySelectorAll('.cart-drawer-shipping-rate')
      );

      if (!oldRows.length) return;

      const root = window.Shopify?.routes?.root || '/';
      const zip = input.value.replace(/\D/g, '');

      const cartResponse = await fetch(root + 'cart.js', {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (!cartResponse.ok) {
        throw new Error('Não foi possível atualizar o total.');
      }

      const cart = await cartResponse.json();
      const subtotalCents = Number(cart.total_price);

      if (!Number.isFinite(subtotalCents)) return;

      /*
        Consulta o resultado já preparado para recuperar
        delivery_days de cada transportadora.
      */
      let carrierRates = [];

      try {
        const cepResponse = await fetch(
          `https://viacep.com.br/ws/${zip}/json/`
        );

        if (cepResponse.ok) {
          const address = await cepResponse.json();

          if (!address.erro) {
            const params = new URLSearchParams();

            params.append('shipping_address[zip]', zip);
            params.append('shipping_address[country]', 'Brazil');
            params.append(
              'shipping_address[province]',
              address.uf
            );
            params.append(
              'shipping_address[city]',
              address.localidade
            );

            const response = await fetch(
              root +
                'cart/async_shipping_rates.json?' +
                params.toString(),
              {
                cache: 'no-store',
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              }
            );

            if (response.ok) {
              const data = await response.json();

              if (Array.isArray(data?.shipping_rates)) {
                carrierRates = data.shipping_rates;
              }
            }
          }
        }
      } catch (error) {
        console.warn('Não foi possível consultar os prazos:', error);
      }

      const options = oldRows.map((row) => {
        const name =
          row.querySelector('.shipping-rate-name')
            ?.textContent.trim() || '';

        const priceText =
          row.querySelector('.shipping-rate-price')
            ?.textContent.trim() || '';

        const parsedPrice = /gr[aá]tis/i.test(priceText)
          ? 0
          : Number(
              priceText
                .replace(/[^\d,.-]/g, '')
                .replace(/\./g, '')
                .replace(',', '.')
            );

        const carrier = carrierRates.find(
          (rate) => normalize(rate.name) === normalize(name)
        );

        const priceCents = carrier
          ? Math.round(Number(carrier.price) * 100)
          : Math.round(parsedPrice * 100);

        let deadline =
          row.querySelector('.shipping-rate-deadline')
            ?.textContent.trim() || '';

        const days = (carrier?.delivery_days || [])
          .filter(
            (value) =>
              value !== null &&
              value !== '' &&
              Number.isFinite(Number(value)) &&
              Number(value) >= 0
          )
          .map(Number);

        if (days.length) {
          const maximum = Math.max(...days);

          deadline = maximum === 1
            ? 'Em até 1 dia útil'
            : `Em até ${maximum} dias úteis`;
        } else if (!deadline && carrier?.description) {
          deadline = carrier.description;
        }

        return { name, priceCents, deadline };
      }).filter(
        (option) =>
          option.name &&
          Number.isFinite(option.priceCents) &&
          option.priceCents >= 0
      );

      if (!options.length) return;

      const totalElement = this.querySelector(
        '.totals .totals__total-value'
      );

      const previousName = this.selectedShippingName;
      const previousZip = this.selectedShippingZip;

      const fragment = document.createDocumentFragment();
      const buttons = [];

      const selectOption = (index) => {
        const option = options[index];

        this.selectedShippingName = option.name;
        this.selectedShippingZip = zip;

        buttons.forEach((button, buttonIndex) => {
          const selected = buttonIndex === index;

          button.classList.toggle('is-selected', selected);
          button.setAttribute(
            'aria-pressed',
            String(selected)
          );
        });

        if (totalElement) {
          totalElement.textContent = money(
            subtotalCents + option.priceCents
          );
        }
      };

      options.forEach((option, index) => {
        const button = document.createElement('button');
        button.type = 'button';

        button.className = 'cart-drawer-shipping-rate';

        if (!option.deadline) {
          button.classList.add('without-deadline');
        }

        button.setAttribute('aria-pressed', 'false');

        const name = document.createElement('span');
        name.className = 'shipping-rate-name';
        name.textContent = option.name;

        const price = document.createElement('strong');
        price.className = 'shipping-rate-price';
        price.textContent = option.priceCents === 0
          ? 'Grátis'
          : money(option.priceCents);

        const deadline = document.createElement('span');
        deadline.className = 'shipping-rate-deadline';
        deadline.textContent = option.deadline;

        button.append(name, price, deadline);

        button.addEventListener('click', () => {
          selectOption(index);
        });

        buttons.push(button);
        fragment.appendChild(button);
      });

      results.replaceChildren(fragment);

      /*
        Mantém a escolha ao recalcular o mesmo CEP.
        Na primeira cotação, seleciona o menor preço.
      */
      let selectedIndex = previousZip === zip
        ? options.findIndex(
            (option) => option.name === previousName
          )
        : -1;

      if (selectedIndex < 0) {
        selectedIndex = options.reduce(
          (best, option, index) =>
            option.priceCents < options[best].priceCents
              ? index
              : best,
          0
        );
      }

      selectOption(selectedIndex);
    } catch (error) {
      console.error('Erro ao preparar seleção de frete:', error);
    } finally {
      this.shippingSelectionBusy = false;
    }
  };
})();/* Conecta o botão Calcular à função atualizada */
(() => {
  if (window.emporioShippingClickFixed) return;
  window.emporioShippingClickFixed = true;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '#CartDrawer-ZipButton'
      );

      if (!button) return;

      const drawer = button.closest('cart-drawer');
      const Drawer = customElements.get('cart-drawer');

      if (
        !drawer ||
        !Drawer?.prototype.shippingSelectionEnabled
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      Drawer.prototype.handleCustomCartActions.call(
        drawer,
        event
      );
    },
    true
  );
})();